import React, { Component } from 'react';
import { Route, Switch, RouteComponentProps } from 'react-router-dom';
import CompanyInfoDetail from './Detail';
import CompanyInfoEdit from './Edit';
import EditEntrance from 'containers/OutCompanyManagement/OutCompanyInfo/EditEntrance';
import DetailsEntrance from 'containers/OutCompanyManagement/OutCompanyInfo/DetailsEntrance';
import EditNew from './EditNew';

class CompanyInfo extends Component<RouteComponentProps, any> {

  public render() {
    const { match: { path } } = this.props
    return (
      <Switch>
        <Route exact path={`${path}`} component={DetailsEntrance} />
        <Route path={`${path}/edit`} component={EditEntrance} />
        <Route path={`${path}/editNew`} component={EditNew} />
      </Switch>
    );
  }
}

export default CompanyInfo;
